import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface noticia {
    codigo: string,
    nombre: string,
    ubicacion: string,
    fechaPublicacion: Date,
    fechaTermino: Date,
}

@Module
export default class NoticiaModule extends VuexModule {
  errors = {};
  noticia = {} as noticia;
  noticias = [] as Array<noticia>;

  /**
   * Get current noticia object
   * @returns Noticia
   */
  get currentNoticia(): noticia {
    return this.noticia;
  }

  /**
   * Get errors
   * @returns array
   */
  get getNoticiaErrors() {
    return this.errors;
  }

  @Mutation
  [Mutations.SET_NOTICIA_ERROR](error) {
    this.errors = error;
  }

  @Mutation
  [Mutations.SET_NOTICIA](noticia) {
    this.noticia = noticia;
  }

  @Mutation
  [Mutations.SET_NOTICIAS](groups) {
    this.noticias = groups;
  }

  @Action
  [Actions.GET_NOTICIAS]() {
    return ApiService.get(`Noticia/v1/noticias`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_NOTICIAS, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_NOTICIA_ERROR, response.data.errors);
      });
  }
  @Action
  [Actions.GET_NOTICIA](id) {
    return ApiService.get(`Noticia/v1/noticias/noticia/${id}`)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_NOTICIA, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_NOTICIA_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.DELETE_NOTICIA](params) {
    return ApiService.updateBlob(`Noticia/v1/delete/noticias`, params)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_NOTICIAS, data);
        console.log(data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_NOTICIA_ERROR, response.data.errors);
      });
  }

  @Action
  [Actions.CREATE_NOTICIA](values) {
    return ApiService.postBlob("/Noticia/v1/cargar", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_NOTICIA, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_NOTICIA_ERROR, response.data.errors);
        throw new Error();
      });
  }

  @Action
  [Actions.EDIT_NOTICIA](values) {
    return ApiService.putBlob("/Noticia/v1/edit/noticia", values)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_NOTICIA, data);
        return data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_NOTICIA_ERROR, response.data.errors);
        throw new Error();
      });
  }
}